import nav from './module/nav';
import changeColor from './module/change-color';
import pagination from './module/pagination';
import {autoHeight} from "./module/autoHeight"

$('a:not(".no-scroll")').click(function(){
	const header_h = $(".l-header").outerHeight();
	const href= $(this).attr("href");
	const target = $(href);
	const position = target.offset().top - header_h;
	$('body,html').stop().animate({scrollTop:position}, 500,'swing');
	return false;
});

function spFillHeight() {
  const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh',`${vh}px`);
  }

  window.addEventListener('resize', setFillHeight);
  setFillHeight();
}

function resize_height() {
	const $panel_ttl = $('.p-panel__ttl');
	autoHeight($panel_ttl)
}

nav();
changeColor();
pagination();

$(window).on('load resize', () => {
	spFillHeight();

	if(window.innerWidth > 768) {
		resize_height();
	}
});
